import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { tarifasApi, errMsg } from "./api";
import { ConnectionsBar } from "./ConnectionsBar";
import { ProvidersTable } from "./ProvidersTable";
import { ProviderTarifas } from "./ProviderTarifas";
import { DriveFiles } from "./DriveFiles";
import { FileDetail } from "./FileDetail";
import { KimkimCatalog } from "./KimkimCatalog";
import { Registry } from "./Registry";

export default function TarifasPanel() {
  const [providers, setProviders] = useState([]);
  const [googleConnected, setGoogleConnected] = useState(false);
  const [openFile, setOpenFile] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [sub, setSub] = useState("files");
  const [openProvider, setOpenProvider] = useState(null);

  const loadProviders = useCallback(async () => {
    try {
      setProviders(await tarifasApi.providers());
    } catch (e) {
      toast.error(errMsg(e, "No se pudieron cargar los proveedores"));
    }
  }, []);

  useEffect(() => {
    loadProviders();
    tarifasApi.googleStatus().then((s) => setGoogleConnected(!!s.connected)).catch(() => {});
    const params = new URLSearchParams(window.location.search);
    if (params.get("google") === "connected") {
      toast.success("Google Drive conectado correctamente");
      setGoogleConnected(true);
      window.history.replaceState({}, "", window.location.pathname);
    } else if (params.get("google") === "error") {
      toast.error(`No se pudo conectar Google: ${params.get("msg") || ""}`);
      window.history.replaceState({}, "", window.location.pathname);
    }
  }, [loadProviders]);

  const bump = () => setRefreshKey((k) => k + 1);

  return (
    <div className="space-y-4" data-testid="tarifas-panel">
      <div>
        <h2 className="font-heading text-lg md:text-xl font-bold tracking-tight">Actualización de tarifas · Drive → KimKim</h2>
        <p className="text-sm text-muted-foreground">Lee los tarifarios de los proveedores en Google Drive, los empareja con vuestras actividades de KimKim y, solo cuando tú lo ordenes, actualiza los precios con el neto + 8 %.</p>
      </div>
      <ConnectionsBar onCatalogSynced={() => { bump(); loadProviders(); }} />

      {openFile ? (
        <FileDetail fileId={openFile.id} onBack={() => { setOpenFile(null); bump(); }} />
      ) : (
        <Tabs value={sub} onValueChange={setSub}>
          <TabsList className="rounded-md">
            <TabsTrigger value="files" data-testid="tarifas-tab-files" className="rounded-md">Archivos de Drive</TabsTrigger>
            <TabsTrigger value="providers" data-testid="tarifas-tab-providers" className="rounded-md">Proveedores</TabsTrigger>
            <TabsTrigger value="catalog" data-testid="tarifas-tab-catalog" className="rounded-md">Catálogo KimKim</TabsTrigger>
            <TabsTrigger value="registry" data-testid="tarifas-tab-registry" className="rounded-md">Registro</TabsTrigger>
          </TabsList>
          <TabsContent value="files" className="mt-3">
            <DriveFiles providers={providers} googleConnected={googleConnected} onOpenFile={setOpenFile} refreshKey={refreshKey} />
          </TabsContent>
          <TabsContent value="providers" className="mt-3">
            {openProvider ? (
              <ProviderTarifas provider={openProvider} onBack={() => { setOpenProvider(null); loadProviders(); }} onOpenFile={(fid) => setOpenFile({ id: fid })} />
            ) : (
              <ProvidersTable providers={providers} onChange={() => { loadProviders(); bump(); }} onOpenTarifas={setOpenProvider} />
            )}
          </TabsContent>
          <TabsContent value="catalog" className="mt-3">
            <KimkimCatalog providers={providers} refreshKey={refreshKey} />
          </TabsContent>
          <TabsContent value="registry" className="mt-3">
            <Registry refreshKey={refreshKey} />
          </TabsContent>
        </Tabs>
      )}
    </div>
  );
}
